import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

const TranslatorInfoModal = ({ isOpen, onClose, translator }) => {
  const { t } = useTranslation();

  if (!isOpen || !translator) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>{t('translator_details', 'Çevirmen Detayları')}</h3>
          <button onClick={onClose} className="close-btn">&times;</button>
        </div>
        <div className="info-modal-body">
          <div className="info-row">
            <span>{t('full_name')}</span>
            <strong>{translator.first_name} {translator.last_name}</strong>
          </div>
          <div className="info-row">
            <span>{t('email_address')}</span>
            <strong>{translator.email}</strong>
          </div>
          <div className="info-row">
            <span>{t('phone')}</span>
            <strong>{translator.phone_country_code} {translator.phone_number}</strong>
          </div>
          <div className="info-row">
            <span>{t('total_completed_jobs', 'Toplam Tamamlanan İş')}</span>
            <strong>{translator.completed_jobs}</strong>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default TranslatorInfoModal;